import React from "react";
import { Copy, X, Printer } from "lucide-react";

export default function TextModal({ title, content, onClose }) {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(content);
    alert("Copiado!");
  };

  const handlePrint = () => {
    const printWin = window.open("", "_blank");
    if (!printWin) return alert("Habilite popups no navegador para imprimir.");
    printWin.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>${title || "Filipeta de Produção"}</title>
        <style>
          @page { size: 80mm auto; margin: 0; }
          body { font-family: 'Courier New', Courier, monospace, ui-monospace; font-size: 13px; line-height: 1.25; margin: 0; padding: 12px; color: #000; white-space: pre-wrap; word-break: break-word; }
          @media print { body { padding: 2mm 3mm; } }
        </style>
      </head>
      <body>
        <pre style="margin:0; font-family:inherit; white-space: pre-wrap;">${content}</pre>
        <script>
          window.onload = function() {
            window.print();
          };
        </script>
      </body>
      </html>
    `);
    printWin.document.close();
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/60 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
      <div className="bg-white w-full max-w-md rounded-xl shadow-2xl overflow-hidden flex flex-col">
        <div className="bg-slate-800 p-4 flex justify-between items-center text-white">
          <div className="flex items-center gap-2">
            <Printer size={18} className="text-amber-400" />
            <h3 className="font-bold">{title || "Etiquetas de Produção"}</h3>
          </div>
          <button
            onClick={onClose}
            className="hover:bg-white/20 p-1 rounded transition-colors cursor-pointer"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4 bg-slate-50">
          <textarea
            className="w-full h-72 p-3 font-mono text-xs border border-slate-300 rounded-lg focus:border-blue-500 outline-none resize-none bg-white text-slate-800"
            readOnly
            value={content}
          />
        </div>
        <div className="p-4 border-t bg-white flex gap-2">
          <button
            onClick={handlePrint}
            className="flex-1 bg-slate-800 hover:bg-slate-900 text-white font-bold py-2 rounded-lg flex items-center justify-center gap-2 transition-colors cursor-pointer"
          >
            <Printer size={16} /> Imprimir
          </button>
          <button
            onClick={copyToClipboard}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 rounded-lg flex items-center justify-center gap-2 transition-colors cursor-pointer"
          >
            <Copy size={16} /> Copiar
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 border border-slate-300 font-bold text-slate-600 hover:bg-slate-50 rounded-lg cursor-pointer"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
